import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import { removeQueryParam } from "@faire/help-center-utils/lib/removeQueryParam";
import { QueryParameters as supportSelfServeParams } from "@faire/web-api/routes/support/self-serve";
import { useQueryParams } from "@faire/web/ui/hooks/useQueryParams";
import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { setSelectedBrandOrderToLocalStorage } from "../utils/localStorage";
import { useSelfServeContextStore } from "./SelfServeContext";
import { usePaginatedBrandOrders } from "./usePaginatedBrandOrders";
import { useTree } from "./useTree";
export var useExistedBrandOrderEffect = function useExistedBrandOrderEffect() {
  var _usePaginatedBrandOrd = usePaginatedBrandOrders(),
    brandOrders = _usePaginatedBrandOrd.brandOrders,
    isLoading = _usePaginatedBrandOrd.isLoading,
    dataUpdatedAt = _usePaginatedBrandOrd.dataUpdatedAt;
  var _useQueryParams = useQueryParams(supportSelfServeParams.parse),
    brandOrderToken = _useQueryParams.brand_order_token;
  var history = useHistory();
  var location = useLocation();
  var _useSelfServeContextS = useSelfServeContextStore(["selectedBrandOrder", "brandOrders"]),
    _useSelfServeContextS2 = _slicedToArray(_useSelfServeContextS, 2),
    _useSelfServeContextS3 = _useSelfServeContextS2[0],
    existingSelectedBrandOrder = _useSelfServeContextS3.selectedBrandOrder,
    existingBrandOrders = _useSelfServeContextS3.brandOrders,
    setSelfServeContextStore = _useSelfServeContextS2[1];
  var _useTree = useTree(),
    tree = _useTree.tree;
  var brandOrder = brandOrders === null || brandOrders === void 0 ? void 0 : brandOrders.find(function (brandOrder) {
    var _brandOrder$brand_ord;
    if (!brandOrder) {
      return false;
    }
    return ((_brandOrder$brand_ord = brandOrder.brand_order) === null || _brandOrder$brand_ord === void 0 ? void 0 : _brandOrder$brand_ord.token) === brandOrderToken;
  });
  useEffect(function () {
    if (brandOrderToken && brandOrder && !existingSelectedBrandOrder) {
      setSelfServeContextStore({
        selectedBrandOrder: brandOrder
      });
      setSelectedBrandOrderToLocalStorage(brandOrder);
      removeQueryParam(history, location, "brand_order_token");
    }
  }, [history, location, brandOrder, brandOrderToken, existingSelectedBrandOrder, setSelfServeContextStore, tree]);
  useEffect(function () {
    if (brandOrders && !existingBrandOrders) {
      setSelfServeContextStore({
        brandOrders: brandOrders
      });
    }
  }, [brandOrders, existingBrandOrders, setSelfServeContextStore]);
  return {
    isLoading: isLoading,
    dataUpdatedAt: dataUpdatedAt
  };
};